import { SELECT_LOOKUP, DATE, HIDDEN, TEXT_FIELD } from '../InputTypes';

export const fields = [
  'CareerEmployer',
  'CareerJob',
  'CareerCity',
  'CareerCountryName',
  // 'CareerPeriodBegda',
  // 'CareerPeriodEnda',
];

export const detailFields = [
  ...fields,
  'CareerPeriodBegda',
  'CareerPeriodEnda',
];

export const entityMap = {
  EmployeeMasterID: {
    type: HIDDEN,
  },
  EmployeeMasterCareerID: {
    type: HIDDEN,
  },
  CareerEmployer: {
    type: TEXT_FIELD,
  },
  CareerJob: {
    type: TEXT_FIELD,
  },
  CareerCity: {
    type: TEXT_FIELD,
  },
  CareerCountryID: {
    type: SELECT_LOOKUP,
    lookup: {
      entity: 'SysCountry',
      value: 'SysCountryID',
      label: 'SysCountryName',
    },
  },
  CareerPeriodBegda: {
    type: DATE,
  },
  CareerPeriodEnda: {
    type: DATE,
  },
};



// WEBPACK FOOTER //
// ./src/constants/fields/EmployeeMasterCareer.js